import { render, staticRenderFns } from "./Mfa.vue?vue&type=template&id=21f1b1ed&scoped=true"
import script from "@/components/mfa/Mfa.ts?vue&type=script&lang=ts&external"
export * from "@/components/mfa/Mfa.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/mfa/mfa.scss?vue&type=style&index=0&id=21f1b1ed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1b1ed",
  null
  
)

export default component.exports